module.exports = __webpack_public_path__ + "static/media/nosearch.3caba38d.svg";